// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__1rNSp","infoBtn":"quickbooks_infoBtn__3A79E","formBox":"quickbooks_formBox__3Odmn","formFooter":"quickbooks_formFooter__3cyWa"};